// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/app/v1/app_managed.proto" (package "c1.api.app.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { Facets } from "../../search/v1/facet";
import { Any } from "../../../../google/protobuf/any";
import { Timestamp } from "../../../../google/protobuf/timestamp";
/**
 * @generated from protobuf message c1.api.app.v1.AppManagedStateBinding
 */
export interface AppManagedStateBinding {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string resource_type_id = 2;
     */
    resourceTypeId: string;
    /**
     * @generated from protobuf field: string resource_id = 3;
     */
    resourceId: string;
    /**
     * @generated from protobuf field: string display_name = 4;
     */
    displayName: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 5;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 6;
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 7;
     */
    deletedAt?: Timestamp;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppManagedState state = 8;
     */
    state?: AppManagedState;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppManagedState
 */
export interface AppManagedState {
    /**
     * @generated from protobuf oneof: state
     */
    state: {
        oneofKind: "unmanaged";
        /**
         * @generated from protobuf field: c1.api.app.v1.AppManagedState.AppManagedStateUnmanaged unmanaged = 100;
         */
        unmanaged: AppManagedState_AppManagedStateUnmanaged;
    } | {
        oneofKind: "managed";
        /**
         * @generated from protobuf field: c1.api.app.v1.AppManagedState.AppManagedStateManaged managed = 101;
         */
        managed: AppManagedState_AppManagedStateManaged;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.app.v1.AppManagedState.AppManagedStateUnmanaged
 */
export interface AppManagedState_AppManagedStateUnmanaged {
}
/**
 * @generated from protobuf message c1.api.app.v1.AppManagedState.AppManagedStateManaged
 */
export interface AppManagedState_AppManagedStateManaged {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppManagedStateBindingView
 */
export interface AppManagedStateBindingView {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppManagedStateBinding app_management_state_binding = 1;
     */
    appManagementStateBinding?: AppManagedStateBinding;
    /**
     * @generated from protobuf field: string app_path = 2;
     */
    appPath: string;
    /**
     * @generated from protobuf field: string resource_path = 3;
     */
    resourcePath: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppManagedStateBindingExpandMask
 */
export interface AppManagedStateBindingExpandMask {
    /**
     * @generated from protobuf field: repeated string paths = 1;
     */
    paths: string[];
}
/**
 * @generated from protobuf message c1.api.app.v1.GetAppManagedStateBindingRequest
 */
export interface GetAppManagedStateBindingRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string resource_type_id = 2;
     */
    resourceTypeId: string;
    /**
     * @generated from protobuf field: string resource_id = 3;
     */
    resourceId: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppManagedStateBindingExpandMask expand_mask = 4;
     */
    expandMask?: AppManagedStateBindingExpandMask;
}
/**
 * @generated from protobuf message c1.api.app.v1.GetAppManagedStateBindingResponse
 */
export interface GetAppManagedStateBindingResponse {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppManagedStateBindingView app_management_state = 1;
     */
    appManagementState?: AppManagedStateBindingView;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchAppManagedStateBindingsRequest
 */
export interface SearchAppManagedStateBindingsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * Query the apps with a fuzzy search on display name.
     *
     * @generated from protobuf field: string query = 3;
     */
    query: string;
    /**
     * @generated from protobuf field: repeated int32 states = 4;
     */
    states: number[];
    /**
     * @generated from protobuf field: c1.api.app.v1.AppManagedStateBindingExpandMask expand_mask = 5;
     */
    expandMask?: AppManagedStateBindingExpandMask;
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppManagedStateBindingRef refs = 6;
     */
    refs: AppManagedStateBindingRef[];
    /**
     * @generated from protobuf field: repeated string app_ids = 7;
     */
    appIds: string[];
}
/**
 * @generated from protobuf message c1.api.app.v1.ListAppManagedStateBindingsRequest
 */
export interface ListAppManagedStateBindingsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string app_id = 3;
     */
    appId: string;
    /**
     * @generated from protobuf field: string resource_type_id = 4;
     */
    resourceTypeId: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppManagedStateBindingExpandMask expand_mask = 5;
     */
    expandMask?: AppManagedStateBindingExpandMask;
}
/**
 * The ListAppManagedStateBindingsResponse message contains a list of results and a nextPageToken if applicable.
 *
 * @generated from protobuf message c1.api.app.v1.ListAppManagedStateBindingsResponse
 */
export interface ListAppManagedStateBindingsResponse {
    /**
     * The list of results containing up to X results, where X is the page size defined in the request.
     *
     * @generated from protobuf field: repeated c1.api.app.v1.AppManagedStateBindingView list = 1;
     */
    list: AppManagedStateBindingView[];
    /**
     * The nextPageToken is shown for the next page if the number of results is larger than the max page size.
     * The server returns one page of results and the nextPageToken until all results are retreived.
     * To retrieve the next page, use the same request and append a pageToken field with the value of nextPageToken shown on the previous page.
     *
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchAppManagedStateBindingsResponse
 */
export interface SearchAppManagedStateBindingsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppManagedStateBindingView list = 1;
     */
    list: AppManagedStateBindingView[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.app.v1.AppManagedStateBindingRef
 */
export interface AppManagedStateBindingRef {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string resource_type_id = 2;
     */
    resourceTypeId: string;
    /**
     * @generated from protobuf field: string resource_id = 3;
     */
    resourceId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppManagedStateBindingSearchFilter
 */
export interface AppManagedStateBindingSearchFilter {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppManagedStateBindingRef refs = 1;
     */
    refs: AppManagedStateBindingRef[];
}
/**
 * @generated from protobuf message c1.api.app.v1.PromoteAppManagedStateBindingRequest
 */
export interface PromoteAppManagedStateBindingRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string resource_type_id = 2;
     */
    resourceTypeId: string;
    /**
     * @generated from protobuf field: string resource_id = 3;
     */
    resourceId: string;
    /**
     * @generated from protobuf field: repeated string user_ids = 4;
     */
    userIds: string[];
    /**
     * @generated from protobuf field: c1.api.app.v1.AppManagedStateBindingExpandMask expand_mask = 5;
     */
    expandMask?: AppManagedStateBindingExpandMask;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppManagedStateSearchTermsRequest
 */
export interface AppManagedStateSearchTermsRequest {
    /**
     * @generated from protobuf field: c1.api.app.v1.SearchAppManagedStateBindingsRequest search = 1;
     */
    search?: SearchAppManagedStateBindingsRequest;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppManagedStateSearchTermsRequest.TermType term = 2;
     */
    term: AppManagedStateSearchTermsRequest_TermType;
    /**
     * @generated from protobuf field: string query = 3;
     */
    query: string;
    /**
     * @generated from protobuf field: bool include_count = 4;
     */
    includeCount: boolean;
}
/**
 * @generated from protobuf enum c1.api.app.v1.AppManagedStateSearchTermsRequest.TermType
 */
export enum AppManagedStateSearchTermsRequest_TermType {
    /**
     * @generated from protobuf enum value: UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: APP_IDS = 1;
     */
    APP_IDS = 1
}
/**
 * @generated from protobuf message c1.api.app.v1.AppManagedStateSearchTermsResponse
 */
export interface AppManagedStateSearchTermsResponse {
    /**
     * @generated from protobuf field: c1.api.search.v1.Facets facets = 1;
     */
    facets?: Facets;
}
/**
 * Currently unused
 *
 * @generated from protobuf message c1.api.app.v1.MutateAppManagedStateBindingRequest
 */
export interface MutateAppManagedStateBindingRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string resource_type_id = 2;
     */
    resourceTypeId: string;
    /**
     * @generated from protobuf field: string resource_id = 3;
     */
    resourceId: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppManagedState state = 4;
     */
    state?: AppManagedState;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppManagedStateBindingExpandMask expand_mask = 5;
     */
    expandMask?: AppManagedStateBindingExpandMask;
}
// @generated message type with reflection information, may provide speed optimized methods
class AppManagedStateBinding$Type extends MessageType<AppManagedStateBinding> {
    constructor() {
        super("c1.api.app.v1.AppManagedStateBinding", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "resource_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 3, name: "resource_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 4, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 6, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 7, name: "deleted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 8, name: "state", kind: "message", T: () => AppManagedState, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppManagedStateBinding
 */
export const AppManagedStateBinding = new AppManagedStateBinding$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppManagedState$Type extends MessageType<AppManagedState> {
    constructor() {
        super("c1.api.app.v1.AppManagedState", [
            { no: 100, name: "unmanaged", kind: "message", oneof: "state", T: () => AppManagedState_AppManagedStateUnmanaged },
            { no: 101, name: "managed", kind: "message", oneof: "state", T: () => AppManagedState_AppManagedStateManaged }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppManagedState
 */
export const AppManagedState = new AppManagedState$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppManagedState_AppManagedStateUnmanaged$Type extends MessageType<AppManagedState_AppManagedStateUnmanaged> {
    constructor() {
        super("c1.api.app.v1.AppManagedState.AppManagedStateUnmanaged", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppManagedState.AppManagedStateUnmanaged
 */
export const AppManagedState_AppManagedStateUnmanaged = new AppManagedState_AppManagedStateUnmanaged$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppManagedState_AppManagedStateManaged$Type extends MessageType<AppManagedState_AppManagedStateManaged> {
    constructor() {
        super("c1.api.app.v1.AppManagedState.AppManagedStateManaged", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppManagedState.AppManagedStateManaged
 */
export const AppManagedState_AppManagedStateManaged = new AppManagedState_AppManagedStateManaged$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppManagedStateBindingView$Type extends MessageType<AppManagedStateBindingView> {
    constructor() {
        super("c1.api.app.v1.AppManagedStateBindingView", [
            { no: 1, name: "app_management_state_binding", kind: "message", T: () => AppManagedStateBinding },
            { no: 2, name: "app_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "resource_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppManagedStateBindingView
 */
export const AppManagedStateBindingView = new AppManagedStateBindingView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppManagedStateBindingExpandMask$Type extends MessageType<AppManagedStateBindingExpandMask> {
    constructor() {
        super("c1.api.app.v1.AppManagedStateBindingExpandMask", [
            { no: 1, name: "paths", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { in: ["*"] } }, ignoreEmpty: true } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppManagedStateBindingExpandMask
 */
export const AppManagedStateBindingExpandMask = new AppManagedStateBindingExpandMask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAppManagedStateBindingRequest$Type extends MessageType<GetAppManagedStateBindingRequest> {
    constructor() {
        super("c1.api.app.v1.GetAppManagedStateBindingRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "resource_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "1", maxLen: "512" } } } },
            { no: 3, name: "resource_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "1", maxLen: "512" } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => AppManagedStateBindingExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.GetAppManagedStateBindingRequest
 */
export const GetAppManagedStateBindingRequest = new GetAppManagedStateBindingRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAppManagedStateBindingResponse$Type extends MessageType<GetAppManagedStateBindingResponse> {
    constructor() {
        super("c1.api.app.v1.GetAppManagedStateBindingResponse", [
            { no: 1, name: "app_management_state", kind: "message", T: () => AppManagedStateBindingView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.GetAppManagedStateBindingResponse
 */
export const GetAppManagedStateBindingResponse = new GetAppManagedStateBindingResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppManagedStateBindingsRequest$Type extends MessageType<SearchAppManagedStateBindingsRequest> {
    constructor() {
        super("c1.api.app.v1.SearchAppManagedStateBindingsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "states", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { repeated: { unique: true, items: { int32: { gte: 100 } }, ignoreEmpty: true } } } },
            { no: 5, name: "expand_mask", kind: "message", T: () => AppManagedStateBindingExpandMask },
            { no: 6, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppManagedStateBindingRef },
            { no: 7, name: "app_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "100", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppManagedStateBindingsRequest
 */
export const SearchAppManagedStateBindingsRequest = new SearchAppManagedStateBindingsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAppManagedStateBindingsRequest$Type extends MessageType<ListAppManagedStateBindingsRequest> {
    constructor() {
        super("c1.api.app.v1.ListAppManagedStateBindingsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "resource_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "1", maxLen: "512" } } } },
            { no: 5, name: "expand_mask", kind: "message", T: () => AppManagedStateBindingExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListAppManagedStateBindingsRequest
 */
export const ListAppManagedStateBindingsRequest = new ListAppManagedStateBindingsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAppManagedStateBindingsResponse$Type extends MessageType<ListAppManagedStateBindingsResponse> {
    constructor() {
        super("c1.api.app.v1.ListAppManagedStateBindingsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppManagedStateBindingView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListAppManagedStateBindingsResponse
 */
export const ListAppManagedStateBindingsResponse = new ListAppManagedStateBindingsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppManagedStateBindingsResponse$Type extends MessageType<SearchAppManagedStateBindingsResponse> {
    constructor() {
        super("c1.api.app.v1.SearchAppManagedStateBindingsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppManagedStateBindingView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppManagedStateBindingsResponse
 */
export const SearchAppManagedStateBindingsResponse = new SearchAppManagedStateBindingsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppManagedStateBindingRef$Type extends MessageType<AppManagedStateBindingRef> {
    constructor() {
        super("c1.api.app.v1.AppManagedStateBindingRef", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "resource_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "1", maxLen: "512" } } } },
            { no: 3, name: "resource_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "1", maxLen: "512" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppManagedStateBindingRef
 */
export const AppManagedStateBindingRef = new AppManagedStateBindingRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppManagedStateBindingSearchFilter$Type extends MessageType<AppManagedStateBindingSearchFilter> {
    constructor() {
        super("c1.api.app.v1.AppManagedStateBindingSearchFilter", [
            { no: 1, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppManagedStateBindingRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "300" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppManagedStateBindingSearchFilter
 */
export const AppManagedStateBindingSearchFilter = new AppManagedStateBindingSearchFilter$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PromoteAppManagedStateBindingRequest$Type extends MessageType<PromoteAppManagedStateBindingRequest> {
    constructor() {
        super("c1.api.app.v1.PromoteAppManagedStateBindingRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "resource_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "1", maxLen: "512" } } } },
            { no: 3, name: "resource_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "1", maxLen: "512" } } } },
            { no: 4, name: "user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } }, ignoreEmpty: true } } } },
            { no: 5, name: "expand_mask", kind: "message", T: () => AppManagedStateBindingExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.PromoteAppManagedStateBindingRequest
 */
export const PromoteAppManagedStateBindingRequest = new PromoteAppManagedStateBindingRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppManagedStateSearchTermsRequest$Type extends MessageType<AppManagedStateSearchTermsRequest> {
    constructor() {
        super("c1.api.app.v1.AppManagedStateSearchTermsRequest", [
            { no: 1, name: "search", kind: "message", T: () => SearchAppManagedStateBindingsRequest },
            { no: 2, name: "term", kind: "enum", T: () => ["c1.api.app.v1.AppManagedStateSearchTermsRequest.TermType", AppManagedStateSearchTermsRequest_TermType] },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "include_count", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppManagedStateSearchTermsRequest
 */
export const AppManagedStateSearchTermsRequest = new AppManagedStateSearchTermsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppManagedStateSearchTermsResponse$Type extends MessageType<AppManagedStateSearchTermsResponse> {
    constructor() {
        super("c1.api.app.v1.AppManagedStateSearchTermsResponse", [
            { no: 1, name: "facets", kind: "message", T: () => Facets }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppManagedStateSearchTermsResponse
 */
export const AppManagedStateSearchTermsResponse = new AppManagedStateSearchTermsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MutateAppManagedStateBindingRequest$Type extends MessageType<MutateAppManagedStateBindingRequest> {
    constructor() {
        super("c1.api.app.v1.MutateAppManagedStateBindingRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "resource_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "1", maxLen: "512" } } } },
            { no: 3, name: "resource_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "1", maxLen: "512" } } } },
            { no: 4, name: "state", kind: "message", T: () => AppManagedState },
            { no: 5, name: "expand_mask", kind: "message", T: () => AppManagedStateBindingExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.MutateAppManagedStateBindingRequest
 */
export const MutateAppManagedStateBindingRequest = new MutateAppManagedStateBindingRequest$Type();
/**
 * @generated ServiceType for protobuf service c1.api.app.v1.AppManagedStateService
 */
export const AppManagedStateService = new ServiceType("c1.api.app.v1.AppManagedStateService", [
    { name: "Get", options: { "authz.method": { role: "VIEWER" } }, I: GetAppManagedStateBindingRequest, O: GetAppManagedStateBindingResponse },
    { name: "List", options: { "authz.method": { role: "VIEWER" } }, I: ListAppManagedStateBindingsRequest, O: ListAppManagedStateBindingsResponse },
    { name: "Promote", options: { "authz.method": { role: "OWNER" } }, I: PromoteAppManagedStateBindingRequest, O: GetAppManagedStateBindingResponse },
    { name: "MutateState", options: { "authz.method": { role: "EDITOR" } }, I: MutateAppManagedStateBindingRequest, O: GetAppManagedStateBindingResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.app.v1.AppManagedStateSearchService
 */
export const AppManagedStateSearchService = new ServiceType("c1.api.app.v1.AppManagedStateSearchService", [
    { name: "Search", options: { "authz.method": { role: "VIEWER" } }, I: SearchAppManagedStateBindingsRequest, O: SearchAppManagedStateBindingsResponse },
    { name: "GetSearchTerms", options: { "authz.method": { role: "VIEWER" } }, I: AppManagedStateSearchTermsRequest, O: AppManagedStateSearchTermsResponse }
]);
